import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 24px;\n  background-color: ",
        ";\n  border-radius: 12px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export const OrderCardContainer = styled.div.withConfig({
    componentId: "sc-4ab60c45-0"
})(_templateObject(), (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_100);
